import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, toRefs, watchEffect } from 'vue';
import { CandyMachineConfigLine, NftMetadata } from '@/models';
import { fetchJson } from '@/utils';


export default /*#__PURE__*/_defineComponent({
  props: {
    configLine: null
  },
  setup(__props: any) {

const props = __props as {
  configLine: CandyMachineConfigLine,
}



const { configLine } = toRefs(props);
const loading = ref(false);
const metadata = ref<NftMetadata>({});

watchEffect(async () => {
  try {
    loading.value = true;
    const newMetadata = await fetchJson<NftMetadata>(configLine.value.uri);
    if (newMetadata) {
      metadata.value = newMetadata;
    }
  } finally {
    loading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_nft_card = _resolveComponent("nft-card")!

  return (_openBlock(), _createBlock(_component_nft_card, {
    metadata: metadata.value,
    loading: loading.value,
    error: ! metadata.value.image,
    name: _unref(configLine).name
  }, null, 8, ["metadata", "loading", "error", "name"]))
}
}

})